import { render, staticRenderFns } from "./FormControlTypeFile.vue?vue&type=template&id=f251844a&scoped=true"
import script from "./FormControlTypeFile.vue?vue&type=script&lang=js"
export * from "./FormControlTypeFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f251844a",
  null
  
)

export default component.exports